/* eslint-disable no-restricted-globals */
import { clientsClaim } from 'workbox-core';
import { precacheAndRoute, cleanupOutdatedCaches, matchPrecache } from 'workbox-precaching';
import { registerRoute, setCatchHandler } from 'workbox-routing';
import { NetworkFirst } from 'workbox-strategies';

clientsClaim();

self.addEventListener('install', () => self.skipWaiting());

precacheAndRoute(self.__WB_MANIFEST);
cleanupOutdatedCaches();

const fileExtensionRegexp = new RegExp('/[^/?]+\\.[^/]+$');

// Use network-first for navigation so index.html is always fetched fresh after a deploy.
// This prevents stale cached HTML from referencing old (404) bundle hashes.
// Falls back to cached response only when offline.
registerRoute(
    ({ request, url }) => {
        if (request.mode !== 'navigate') {
            return false;
        }

        if (url.pathname.startsWith('/_') || url.pathname.startsWith('/api')) {
            return false;
        }

        if (url.pathname.startsWith('/graphql') || url.pathname.startsWith('/webhook')) {
            return false;
        }

        if (fileExtensionRegexp.test(url.pathname)) {
            return false;
        }

        return true;
    },
    new NetworkFirst({
        cacheName: 'navigation-cache',
        networkTimeoutSeconds: 3,
    })
);

// If NetworkFirst fails (network down + no cache entry), fall back to precached index.html.
// This prevents the no-response error on routes like /f/:id that haven't been visited before.
setCatchHandler(({ request }) => {
    if (request.mode === 'navigate') {
        return matchPrecache('/index.html');
    }
    return Response.error();
});

self.addEventListener('message', event => {
    if (event?.data?.type === 'SKIP_WAITING') {
        self.skipWaiting();
    }
});
